import { createTheme } from "@mui/material";
export const theme = createTheme({
  palette: {
    primary: {
      main: "#6ec1e4",
      light: "#8ec1e4",
      dark: "#4ec1e4",
    },
    secondary: {
      main: "#54595F",
      light: "#74595F",
      dark: "#394949",
    },
    text: {
      main: "#7a7a7a",
      light: "#bababa",
      dark: "#4a4a4a",
    },
    accent: {
      main: "#61ce70",
      dark: "#96d518",
      light: "#81ce70",
    },
    background: {
      main: "#f1f1f1",
      dark: "#00294e",
      light: "#ffffff",
    },
  },
});
